module.exports = __webpack_public_path__ + "static/media/Jessica Scarpati.2fa62706.png";